import React, {useEffect, useState} from 'react';
import './ListOfDate.scss';
import {toast} from "react-toastify";

const ListOfDate = ({dateData, onSelect}) => {

  const [selectDay, setSelectDay] = useState("")
  const [selectDate, setSelectDate] = useState("")
  const [jump, setJump] = useState(1)
  const [selectClock, setSelectClock] = useState("")
  const [startTime, setStartTime] = useState(0)
  const [endTime, setEndTime] = useState(0)
  const [currentClock, setCurrentClock] = useState([])
  const currentDate = new Date();
  const currentHours = ('0' + currentDate.getHours()).slice(-2)
  const [reRender, setReRender] = useState(0)

  const selectDayHandler = (v) => {
    if (v.status === "فعال") {
      if (selectDay !== v.day) {
        onSelect("sendingDate", v.date)
        setSelectDay(v.day)
        setSelectDate(v.date)
        setJump(+v.jump)
        setStartTime(+v.startTime)
        setEndTime(+v.endTime)
        setSelectClock("")
        setCurrentClock([])
      }
    } else {
      toast.error("امکان ارسال در این روز نیست")
    }
  }

  useEffect(() => {
    const listOfDays = dateData?.orderDays || []
    
    // decide between the active days
    const activedays = listOfDays
    .filter(day => day.status === "فعال")
    
    // match current day of week with an active day(look for it)
    const matchingToday = activedays.filter(day => day.date === dateData.time)

    // if found any match between current and active days, select that as default
    if (matchingToday.length > 0) selectDayHandler(matchingToday[0])
    // otherwise, go with the first active day
    else selectDayHandler(activedays[0])

  }, [dateData]);

  useEffect(() => {
    if (startTime !== 0 && endTime !== 0) {
      let temp = []
      let i = startTime
      while (i < endTime) {
        let myTime
        if (+(i + jump) > +endTime) {
          myTime = endTime
        } else {
          myTime = i + jump
        }

        if (selectDay === dateData.day) {
          if (+currentHours >= i) {
            temp.push({id: i.toString() + " - " + (myTime).toString(), active: false})
          } else {
            temp.push({id: i.toString() + " - " + (myTime).toString(), active: true})
          }
        } else {
          temp.push({id: i.toString() + " - " + (myTime).toString(), active: true})
        }
        i = i + jump
      }
      setCurrentClock(temp)
      setReRender(reRender + 1)
    }
  }, [startTime, endTime, selectDay]);

  useEffect(() => {
    if (currentClock.length > 0 && dateData.noOrderDays.length > 0) {
      dateData.noOrderDays.forEach((v) => {
        if (v.day === selectDate) {
          currentClock.forEach((q) => {
            let one = q.id.split(" - ")
            debugger
            if ((+one[1] <= (+v.startTime) || +one[0] >= (+v.endTime))) {
              q.active = true
            }else {
              q.active = false
            }
          })
          setCurrentClock([...currentClock])
        }
      })

    }
  }, [reRender]);

  const clockHandler = (v) => {
    if (v.active) {
      setSelectClock(v.id)
      onSelect("sendingTime", v.id)
    } else {
      toast.error("امکان ارسال در این بازه نیست")
    }
  }

  try {
    // A clone of the options style is created named Option
    return (
      <div className="main-date-box">
        <div className="day-side">
          {dateData?.orderDays.map((v, index) => (
            <div className={`box-single-day ${selectDay === v.day && "box-single-day-active"} ${v.status !== "فعال" && "not-active"}`} key={"D" + index}
                 onClick={() => selectDayHandler(v)}>
              <p>{v?.day}</p>
              <p>{v?.date}</p>
            </div>
          ))}
        </div>

        <div className="clock-side">
          {currentClock.length > 0 && currentClock.map((v, index) => (
            <div key={"C" + index} className={`box-clock ${selectClock === v.id ? "box-clock-active" : ""}`}
                 onClick={() => clockHandler(v)}>
              <p className={`${v.active === false ? "not-active" : ""}`}>{v.id}</p>
            </div>
          ))}
        </div>

      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ListOfDate;